import { ApeLogo } from "../icons/ApeLogo";
import { useConfig } from "../providers/ConfigProvider";
import { useUnifiedWidget } from "../providers/UnifiedWidgetProvider";

const WATERMARK_URL = "https://www.salesape.ai/";

const buildWatermarkUrl = (agentId: string) => {
    const params = new URLSearchParams({
        utm_source: "salesape_widget",
        utm_medium: "referral",
        utm_campaign: "powered_by",
        utm_content: agentId,
    });

    // Hostname only — never the full URL, which could carry customer PII.
    if (window.location.hostname) {
        params.set("ref", window.location.hostname);
    }

    return `${WATERMARK_URL}?${params.toString()}`;
}

export const PoweredBySA = () => {
    const { gooberCss } = useUnifiedWidget();
    const { config } = useConfig();
    return (
      <div className={gooberCss({
        textAlign: "center",
        marginTop: "10px",
        marginBottom: "-10px",
      })}>
        <a
            href={buildWatermarkUrl(config.agentId)}
            target="_blank"
            rel="noopener noreferrer"
            className={gooberCss({
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "5px",
            fontSize: "11px",
            color: "#888",
            textDecoration: "none",
            '&:hover': {
                color: "#666",
            },
            })}
        >
            Powered by SalesAPE.ai <ApeLogo width={14} height={14} className={gooberCss({color: "#f724de"})} />
        </a>
      </div>
    )
}